export default __webpack_public_path__ + "static/bwtransport-2-97048f3d35cda7d18e04300d5eaa714b.png";